import React from 'react'

type ViewMode = 'default' | 'sidePanel'

const ViewModeContext = React.createContext<ViewMode>('default')

export function ViewModeProvider({mode = 'default', children}: {mode?: ViewMode; children: React.ReactNode}) {
  return <ViewModeContext value={mode}>{children}</ViewModeContext>
}

export function useViewMode(): ViewMode {
  return React.use(ViewModeContext)
}
